// extracted by mini-css-extract-plugin
export default {"productGallery":"yJ-z","inQuickShop":"zJ-z"};